import { render } from "./SubCategoriesView.vue?vue&type=template&id=4da50e50"
import script from "./SubCategoriesView.vue?vue&type=script&lang=js"
export * from "./SubCategoriesView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/documentation.probabilityworks.cloud/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__